import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';

import Accordion from '../../../components/Accordion';

const NavMenu: React.FC<any> = props => {
    const { main } = props.match.params;

    function render() {
        return (
            <Fragment>
                {props.data.items.map((item, index) => {
                    return (
                        <Accordion
                            key={index}
                            title={<div className="title">{item.title}</div>}
                            children={item.children.map((subItem, i) => {
                                return (
                                    <div key={i} className="link-box">
                                        <NavLink to={`/help/${item.link_code}/${subItem.id}`} title={subItem.title}>
                                            {subItem.title}
                                        </NavLink>
                                    </div>
                                );
                            })}
                            open={item.link_code === main}
                        />
                    );
                })}
            </Fragment>
        );
    }

    return <div className="nav-menu-root">{render()}</div>;
};

export default NavMenu;
